__turbopack_context__.v({
  "buttons": "FullPageError-module-scss-module__9x4tna__buttons",
  "fullpagewrapper": "FullPageError-module-scss-module__9x4tna__fullpagewrapper",
});
